import styled from 'styled-components';
import { Alert } from 'antd';

const StyledAlert = styled(Alert)`
  .ant-alert-message {
    font-size: ${({ isMobile }) => (isMobile ? '20px' : '16px')};
  }

  .ant-alert-description {
    font-size: ${({ isMobile }) => (isMobile ? '16px' : '14px')};
  }

  .ant-alert-description p {
    margin-bottom: 8px;
  }

  .ant-alert-description .ant-btn.ant-btn-link {
    padding: 0;
  }
`;

const NewApplicantErrorAlert = ({ message, description, isMobile }) => {
  const messageAndDescription = {};

  if (message) {
    messageAndDescription.message = message;
    messageAndDescription.description = description;
  } else {
    messageAndDescription.message = description;
  }

  return <StyledAlert {...messageAndDescription} type="error" showIcon isMobile={isMobile} />;
};

export default NewApplicantErrorAlert;
